// Deps
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

/**
 * Heroes Swiper
 * ------------------------------------------------------- *
 */
// eslint-disable-next-line camelcase
const heroes_swiper = ( function( document ) {
  var selector;
  var options;
  var swiper;
  var count;
  var pagination;
  Swiper.use([ Navigation, Pagination, Autoplay ]);

  const _instance = {};

  options = {
    loop: true,
    autoplay: {
      delay: 3000
    },
    disableOnInteraction: true,
    pagination: {
      clickable: true,
      el: '.swiper-pagination',
      type: 'bullets'
    }
  };

  selector = '.heroes.swiper-container';

  function init() {

	if ( ! document.querySelector( selector ) ) {
		return;
	}

	count = document.querySelectorAll( '.swiper-container .swiper-slide' ).length;
	pagination = document.querySelector( '.swiper-pagination' );

	if ( 1 === count ) {
		document.querySelector( '.swiper-wrapper' ).classList.add( 'disabled' );

		if ( pagination ) {
			document.querySelector( '.swiper-pagination' ).classList.add( 'disabled' );
		}
	}

    swiper = new Swiper( selector, options );

	document.querySelector( '.swiper-container' ).addEventListener( 'mouseenter', function( event ) {
		swiper.autoplay.stop();
	}, false );

	document.querySelector( '.swiper-container' ).addEventListener( 'mouseleave', function( event ) {
		swiper.autoplay.start();
	}, false );
  }

  /**
   * Public
   */
  _instance.init = function() {
    init();
  };

  return _instance;
}( document ) );

// eslint-disable-next-line camelcase
export default heroes_swiper;
